




































































import Vue from 'vue';
import UserApiKeyResourceViewModel from '../../../../services/v1/viewModel/resource/UserApiKeyResourceViewModel';
import ResponsePagingInfo from '../../../../plugins/servicelayer/responseTypes/responsePagingInfo';
import GetApiKeysRequestViewModel from '../../../../services/v1/viewModel/request/ApiKeys/GetApiKeysRequestViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    isKeyCreatedDialogVisible: false,
    requestError: undefined as any,
    list: {},
    pagination: { pageSize: 10 } as ResponsePagingInfo,
    columns: [] as {}[],
    innerPagination: {
      'paging.CurrentPage': undefined as number | undefined,
      'paging.PageSize': undefined as number | undefined,
      'paging.IncludeCount': undefined as boolean | undefined,
      'paging.NoPaging': undefined as boolean | undefined,
    },
    wasAPIKeyCreated: false,
    apiKey: undefined as string | undefined,
  }),
  computed: {
    request() {
      const { userId } = Vue.$router.currentRoute.query;
      const parsedUserId = Number.parseInt(userId as string, 10);
      return new GetApiKeysRequestViewModel().fromModel({ userId: parsedUserId, ...this.innerPagination });
    },
  },
  watch: {
    request() {
      this.writeRequestToQuery();
    },
  },
  beforeMount() {
    this.getQueryFromRequest();
    this.pagination.currentPage = this.innerPagination['paging.CurrentPage'] !;
    this.pagination.pageSize = this.innerPagination['paging.PageSize'] !;
  },
  mounted() {
    this.columns = [
      {
        value: this.$t('core.page.apiKey.label.name'), textAlign: 'left', field: 'name', format: (value: string) => this.$format.ellipsis(value, 30), width: '220px',
      },
      {
        value: this.$t('core.page.apiKey.label.key'), textAlign: 'left', field: 'apiKeyOptions', format: (value:any) => this.buildApiKey(value), width: '400px',
      },
      {
        value: this.$t('core.page.apiKey.label.created'), textAlign: 'left', field: 'created', format: (value: string) => this.$date(value).format('DD.MM.YYYY'), width: '200px',
      },
    ];
  },
  methods: {
    getQueryFromRequest() {
      const queryParams = new GetApiKeysRequestViewModel();
      queryParams.fromQuery(this.$routerUtils.getQueryParams());

      this.innerPagination['paging.CurrentPage'] = queryParams['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = queryParams['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = queryParams['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = queryParams['paging.NoPaging'];
    },
    async writeRequestToQuery() {
      await this.$routerUtils.updateQueryParams(this.request.toQuery(), { preserve: false });
    },
    populateData(params: any) {
      this.innerPagination['paging.CurrentPage'] = params.query['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = params.query['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = params.query['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = params.query['paging.NoPaging'];
      return this.$service.api.core.apiKeys.getApiKeys(this.request);
    },
    buildApiKey(apiKeyOptions: any) {
      let apiKeyFiller = '';
      for (let i = 0; apiKeyOptions.apiKeyLength > i; i += 1) {
        apiKeyFiller += '●';
      }
      return `${apiKeyOptions.apiKeyPrefix}${apiKeyFiller}`;
    },
    regenerateApiKey(id: number) {
      this.$dialog.confirm(this.$t('core.page.apiKey.title.shouldGenerateNewKey'), this.$t('core.page.apiKey.alert.generateNewKeyDescription'))
        .then(async (isConfirmed) => {
          if (isConfirmed) {
            try {
              this.apiKey = await this.$service.api.core.apiKeys.reGenerateApiKey(id);
              this.isKeyCreatedDialogVisible = true;
              this.refresh();
            } catch (error: any) {
              this.requestError = error;
            }
          }
        });
    },
    deleteApiKey(id: number) {
      this.$dialog.confirm(this.$t('core.page.apiKey.title.shouldDeleteKey'), this.$t('core.page.apiKey.alert.deleteKeyDescription'))
        .then(async (isConfirmed) => {
          if (isConfirmed) {
            try {
              await this.$service.api.core.apiKeys.deleteApiKey(id);
              this.refresh();
            } catch (error: any) {
              this.requestError = error;
            }
          }
        });
    },
    addNewApiKey() {
      this.$dialog.prompt(this.$t('core.page.apiKey.title.createNewKey'), this.$t('core.page.apiKey.label.keyName'), '')
        .then(async (promptText : any) => {
          if (promptText !== null) {
            try {
              const request = new UserApiKeyResourceViewModel();
              request.userId = this.request.userId;
              request.name = promptText;
              this.apiKey = await this.$service.api.core.apiKeys.generateApiKey(request);
              this.isKeyCreatedDialogVisible = true;
              this.refresh();
            } catch (error: any) {
              this.requestError = error;
            }
          }
        });
    },
    closeCustomDialog() {
      this.isKeyCreatedDialogVisible = false;
      this.apiKey = undefined as string | undefined;
    },
    refresh() {
      const ordersList = this.$refs.ordersList as any;
      ordersList?.populateList();
    },
    back() {
      this.$router.back();
    },
  },
});
